import { Injectable } from '@angular/core';

import { map, catchError } from 'rxjs/operators';
import { APIBaseService } from './api_base.service';
import { domain } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserAPIService extends APIBaseService {
  namespace = 'user';
  async list(json) {
    const params = json || {};
    const options = { ...this.getHeader(), params };
    const url = `${domain}/${this.namespace}/list`;
    return this.http.get(url, options).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async add(data) {
    const url = `${domain}/${this.namespace}/add`;
    return this.http.post(url, data, this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async get(id) {
    const url = `${domain}/${this.namespace}/${id}/get`;
    return this.http.get(url, this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async update(id, model) {
    const url = `${domain}/${this.namespace}/${id}/update`;
    return this.http.post(url, model, this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }
  async changePassword(id, model) {
    const url = `${domain}/${this.namespace}/${id}/changePassword`;
    return this.http.post(url, model, this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async uploadProfilePic(id, model) {
    const url = `${domain}/${this.namespace}/${id}/uploadProfilePic`;
    return this.http.post(url, model, this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }
  async outletStalls() {
    const url = `${domain}/${this.namespace}/outletStalls`;
    return this.http.get(url, this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }
}
